const reviewCache = []

export class StampedApi {

    constructor(opts) {
        this.apikey = opts.apikey
        this.storeUrl = opts.storeUrl
    }

    getProductRatings(productId) {
        return new Promise((resolve) => {
            
            const raw = JSON.stringify({
                "productIds": [
                  {
                    "productId": productId
                  }
                ],
                "apiKey": this.apikey,
                "storeUrl": this.storeUrl
            });

            const headers = new Headers();
            headers.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'POST',
                headers: headers,
                body: raw,
                redirect: 'follow'
            };

            const endpoint = "http://stamped.io/api/widget/badges?isIncludeBreakdown=true&isincludehtml=false"
    
            fetch(endpoint, requestOptions)
                .then(response => response.text())
                .then(result => {
                    const resultObj = { isError: false, result: JSON.parse(result)}
                    resolve(resultObj)
                })
                .catch(error => resolve({ isError: true, error }));
        })
    }

    getProductReviews(productId, options = {}) {
        return new Promise((resolve) => {
            const page = options.page || this.activePage
            const take = options.take || 10
            const sortReviews  = options.sort || 'featured'
            const storeUrl = this.storeUrl
            const apiKey = this.apikey

            const endpoint = `https://stamped.io/api/widget/reviews?productId=${productId}&take=${take}&page=${page}&minRating=1&sortReviews=${sortReviews}&storeUrl=${storeUrl}&apiKey=${apiKey}`

            const cacheObj = reviewCache.find(resultObj => resultObj.id === endpoint)
            
            if (cacheObj) {
                console.log('Get from cache')
                resolve(cacheObj.resultObj)
                return
            }
    
            const requestOptions = {
                method: 'GET',
                redirect: 'follow'
            };
    
            fetch(endpoint, requestOptions)
                .then(response => response.text())
                .then(result => {
                    const resultObj = { isError: false, result: JSON.parse(result)}
                    reviewCache.push({
                        id: endpoint, 
                        resultObj
                    })
                    resolve(resultObj)
                })
                .catch(error => resolve({ isError: true, error }));
        })
    }

}